export const SOCIAL_LINKS = {
  github: "https://github.com/sirdarthvader",
  linkedin: "https://www.linkedin.com/in/ashish-nandan-singh/",
  twitter: "https://twitter.com/theclever_dev",
  medium: "https://medium.com/@ashishcodes4",
  freecodecamp: "https://www.freecodecamp.org/ashishcodes4/",
  stackoverflow: "https://stackoverflow.com/users/9237049/ashish-singh",
  mail: "mailto:ashishcodes4@gmail.com",
}
